import { useContext } from "react";
import { BackdropContext } from "components/BackdropProvider/BackdropProvider";

export const useBackdrop = () => useContext(BackdropContext);
